

import {Card, Col, Row} from "reactstrap";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {useParams} from "react-router";
import {useSelector} from "react-redux";
import {MdOutlineInfo} from "react-icons/md";
import Button from "../../../../../components/button/Button";
import Icon from "../../../../../components/icon/Icon";
import {Field} from "../../../../../components/fouladyar/field/field";
import {ErrorToaster, SuccessToaster} from "../../../../../shared/toaster";
import {Divider} from "../../../signal/tabs/signals";

export function RejectPublicationReasonModal({publicationId, onClose, onCancel, onReload}) {
    const auth = useSelector((state) => state.auth);
    const { t, i18n } = useTranslation();
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [admExplanation, setAdmExplanation] = useState("");

    async function reject(publicationId) {
        try {
            setIsLoading(true)
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/publication/bot/reject/${publicationId}`, {
                admExplanation: admExplanation
            },{
                headers: {"authorization": `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200) {
                onReload()
                setIsLoading(false)
            }

        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }






    const [reason, setReason] = useState('');


    return (
        <div className="yes-or-no">
            <Button onClick={() => onClose(false)}>
                <Icon name="cross"></Icon>
            </Button>
            <h4 className='d-flex flex-row' style={{padding: "20px 15px 0px 15px", fontSize: "1.25rem"}}>
                لغو انتشار
            </h4>
            <Divider/>

            <div className="change-state-modal-component" style={{padding: "0px 20px", borderRadius: '5px'}}>
                <div className="d-flex flex-column" style={{gap: '5px'}}>
                    <Field
                        className="w-100"
                        label={"توضیحات ادمین"}
                        id={"reason"}
                        name={"reason"}
                        type={'editor'}
                        value={admExplanation}
                        onChange={(e) => {
                            setAdmExplanation(e)
                        }}
                        onBlur={(e) => {

                        }}
                    />
                    <div className="d-flex flex-row" style={{gap: "10px"}} >
                        <MdOutlineInfo size={20} color={"#ccc"}/>
                        لطفا قبل از لغو انتشار، حتما تمام بخش هایی که باید بررسی شوند را با دقت بازنگری کرده و سپس دلایل خود را در کادر بالا وارد کنید.
                    </div>
                </div>




            </div>
            <Divider/>
            <Row className="nk-kycfm-control-list" style={{margin: "10px 10px 30px 10px"}}>
                <Col >
                    <Button disabled={isLoading} className="btn red-bg-color w-100" style={{margin: "10px 0px 0px 0px"}}  onClick={async () => {
                        await reject(publicationId)
                    }}>
                        <span className="yes-or-no-btn-txt" >لغو انتشار</span>
                    </Button>
                </Col>
            </Row>

        </div>
    )
}
